import { SvgIcon } from "@material-ui/core";

export const FlightHorizontal = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 8 8">
      <path d="M8 4C8 3.66316 7.72 3.36842 7.4 3.36842H5.2L3.2 0H2.4L3.4 3.36842H1.2L0.6 2.52632H0L0.4 4L0 5.47368H0.6L1.2 4.63158H3.4L2.4 8H3.2L5.2 4.63158H7.4C7.72 4.63158 8 4.33684 8 4Z" />
    </SvgIcon>
  );
};
